import { useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Row, Col, ListGroup, Image, Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Message from '../components/Message';
import Loader from '../components/Loader';
import { useGetOrderDetailsQuery } from '../slices/ordersApiSlice';
import { useTranslation } from 'react-i18next';
import Paypal from '../components/Paypal/Paypal';

const OrderScreenPaypal = () => {
  const { id: orderId } = useParams();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir().toLowerCase() === 'rtl';
  
  const { deviseInfo } = useSelector((state) => state.devise);

  const {
    data: order,
    isLoading,
    error,
  } = useGetOrderDetailsQuery(orderId);

  // Redirection si déjà payé
  useEffect(() => {
    if (order && order.isPaid) {
      navigate('/my-orders');
    }
  }, [order, navigate]);

  return isLoading ? (
    <Loader />
  ) : error ? (
    <Message variant='danger'>{error}</Message>
  ) : (
    <>
      <h1>Ref {order._id}</h1>
      <Row>
        <Col md={8}>
          <ListGroup variant='flush'>
            <ListGroup.Item>
              <h2>{t('orders')}</h2>
              <p><strong>{t('name')} : </strong> {order.shippingAddress.namePrename}</p>
              <p>
                <strong>{t('email')} : </strong>
                <a href={`mailto:${order.shippingAddress.mail}`}>{order.shippingAddress.mail}</a>
              </p>
              <p><strong>{t('address')} </strong> {order.shippingAddress.adress}</p>
              <p><strong>{t('phonenumber')} : </strong> {order.shippingAddress.tel}</p>
            </ListGroup.Item>

            <ListGroup.Item dir={isRTL ? 'rtl' : 'ltr'}>
              <h2>{t('mode')}</h2>
              <Col><p><strong>{t('mode')} : </strong> {order.paymentMethod}</p></Col>
              <Col><strong>{t('devise')} : </strong> {deviseInfo}</Col>
              {order.isPaid ? (
                <Message variant='success'>Payé le {order.paidAt}</Message>
              ) : (
                <Message variant='danger'>Non payé</Message>
              )}
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>{t('ordsum')}</h2>
              {order.orderItems.length === 0 ? (
                <Message>{t('emptycart')}</Message>
              ) : (
                <ListGroup variant='flush'>
                  {order.orderItems.map((item, index) => (
                    <ListGroup.Item key={index}>
                      <Row>
                        <Col md={1}>
                          <Image src={item.image} alt={item.name} fluid rounded />
                        </Col>
                        <Col><Link to={`/product/${item.product}`}>{item.name}</Link></Col>
                        {deviseInfo === 'EUR' && (
                          <Col md={5}>{t('Price')} : {item.qty} x {item.priceEur}€ = {item.qty * item.priceEur} {deviseInfo}</Col>
                        )}
                        {deviseInfo === 'USD' && (
                          <Col md={5}>{t('Price')} : {item.qty} x {item.priceDol}$ = {item.qty * item.priceDol} {deviseInfo}</Col>
                        )}
                      </Row>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </ListGroup.Item>
          </ListGroup>
        </Col>
        
        <Col md={4}>
          <Card>
            <ListGroup variant='flush'>
              <ListGroup.Item dir={isRTL ? 'rtl' : 'ltr'}>
                <h2>{t('ordsum')}</h2>
              </ListGroup.Item>
              
              <ListGroup.Item>
                <Row>
                  <Col>Articles :</Col>
                  {deviseInfo === 'EUR' && <Col><strong>{order.itemsPriceEur} {deviseInfo}</strong></Col>}
                  {deviseInfo === 'USD' && <Col><strong>{order.itemsPriceDol} {deviseInfo}</strong></Col>}
                </Row>
              </ListGroup.Item>

              {!order.isPaid && (
                <ListGroup.Item>
                  {/* NOUVEAU : On passe le bon prix, la devise et l'ID de commande ! */}
                  {deviseInfo === 'EUR' || deviseInfo === 'USD' ? (
                    <Paypal
                      amount={deviseInfo === 'EUR' ? order.totalPriceEur : order.totalPriceDol}
                      currency={deviseInfo}
                      orderId={order._id}
                    />
                  ) : (
                    <h6>La devise de paiement doit être en Euro ou en Dollar</h6>
                  )}
                </ListGroup.Item>
              )}
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default OrderScreenPaypal;